<template>
	<div :class="['faq-categories-wrapper', {
		active : open
	}]">
		<button 
			id="faq-categories-toggle" 
			:aria-expanded="(open) ? 'true' : 'false'" 
			aria-controls="faq-categories-options" 
			title="Velg kategori"
			:class="['mobile-toggle-button', {
				hidden : !isMobile && !iframeActive,
				active : open
			}]" 
			@click.stop.prevent="open = !open">
			{{ currentCategory.name }}
		</button>
		<nav 
			id="faq-categories-options" 
			aria-controlledby="faq-categories-toggle" 
			:class="[{
				active : open
			}]">
			<button 
				v-for="category in sortedCategories" 
				:class="[{
					active: currentCategory!==null && currentCategory.id===category.id
				}]"
				@click.stop.prevent="switchCategory(category.id)">{{ category.name }}</button>
		</nav>
	</div>
</template>

<script>
export default {
	props: {
		isMobile: {
			type: Boolean,
			required: true,
		},
		isIframe: {
			type: Boolean,
			required: true,
		},
		categories: {
			type: Array,
			required: true,
		},
		currentCategory: {
			type: Object,
			required: false,
		}
	},
	data() {
		return {
			open: false,
		}
	},
	computed: {
		sortedCategories() {
			let categories = Object.values(JSON.parse(JSON.stringify({...this.categories})))
			return categories.sort(( a, b ) => {
				if ( a.sort < b.sort ) {
					return -1;
				}
				if ( a.sort > b.sort ) {
					return 1;
				}
				return 0;
			});
		}
	},
	methods: {
		switchCategory(id) {
			this.open = !this.open
			this.$emit('switchCategory', id);
		},
		sortCategories( a, b ) {
			if ( a.sort < b.sort ) {
				return -1;
			}
			if ( a.sort > b.sort ) {
				return 1;
			}
			return 0;
		}
	}
};
</script>
